/**
 * Ezoic Ad Placeholder Component
 * 
 * Ezoic uses div placeholders with specific IDs.
 * Ezoic's script auto-fills them with optimized ads.
 * 
 * SETUP:
 * 1. In Ezoic dashboard, create ad placeholders
 * 2. Set the placeholder IDs here
 * 3. Block categories in Ezoic: Violence, Adult, Esoteric, Gambling
 */
import React from 'react';

export default function AdBanner({ placeholderId = 'ezoic-pub-ad-placeholder-101', style = {} }) {
  return (
    <div
      id={placeholderId}
      className="w-full flex items-center justify-center"
      style={{ minHeight: '250px', ...style }}
      data-testid="ad-banner"
    />
  );
}
